import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableStructure3D = Loadable({
  loader: () => import('./Structure3D'),
  loading: Loader
});
